import type { ListInstrumentsParams } from '@amarantos/api-client'
import { z } from 'zod/v3'

const baseInstrumentsSearchSchema = z.object({
	page: z.coerce.number().int().positive().default(1),
	perPage: z.coerce.number().int().positive().max(100).default(10),
	search: z.string().default(''),
})

const drawerSearchStateSchema = z.union([
	z.object({
		mode: z.literal('create'),
		instrumentId: z.undefined().optional(),
	}),
	z.object({
		mode: z.literal('edit'),
		instrumentId: z.coerce.number().int().positive(),
	}),
	z.object({
		mode: z.undefined().optional(),
		instrumentId: z.undefined().optional(),
	}),
])

export const instrumentsSearchSchema = baseInstrumentsSearchSchema.and(drawerSearchStateSchema)

export type InstrumentsSearch = z.infer<typeof instrumentsSearchSchema>

export function toListInstrumentsParams(search: InstrumentsSearch): ListInstrumentsParams {
	return {
		page: search.page,
		per_page: search.perPage,
		search: search.search.length > 0 ? search.search : undefined,
	}
}
